import { CustomFontStyle } from "@redotech/redo-content-builder-common/brand-kit";
import { memo } from "react";
import { formatFromUrl } from "./font-format";

const cssString = (value: string) => `"${value.replace(/["\\]/g, "\\$&")}"`;

export interface FontFaceToLoad {
  fontFamily: string;
  style: CustomFontStyle;
}

export function fontFaceCss(fonts: readonly FontFaceToLoad[]): string {
  return fonts
    .filter(({ style }) => style.fontFileUrl)
    .map(
      ({ fontFamily, style }) => `@font-face {
  font-family: ${cssString(fontFamily)};
  src: url(${
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    cssString(style.fontFileUrl!)
  }) format(${
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    cssString(formatFromUrl(style.fontFileUrl!))
  });
  font-weight: ${style.weight || "normal"};
  font-style: ${style.italic ? "italic" : "normal"};
  font-display: swap;
}`,
    )
    .join("\n");
}

/**
 * Brand faces as plain `@font-face` rules on the CDN URL: present at first
 * paint and HTTP-cached, unlike fetch-to-blob loading.
 */
export const CustomFontFaceStyle = memo(function CustomFontFaceStyle({
  fonts,
}: {
  fonts: readonly FontFaceToLoad[];
}) {
  const css = fontFaceCss(fonts);
  if (!css) {
    return null;
  }
  //redontIgnore -- @font-face rules have no Arbiter component and cannot be props or CSS modules
  return <style>{css}</style>;
});
